const PDFAnalysisResult = ({ result, fileName }) => {
  console.log('PDFAnalysisResult props:', { result, fileName });

  if (!result || !result.summary) {
    console.log('결과 없음');
    return null;
  }

  const { summary, metadata } = result;
  const { summary: summaryText, keyPoints, structure } = summary;

  return (
    <div className="mt-8 space-y-6 animate-fadeIn">
      {fileName && (
        <h2 className="text-xl font-bold text-gray-800 mb-4">
          {fileName} 분석 결과
        </h2>
      )}
      
      {/* 메타데이터 섹션 */}
      {metadata && (
        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100 text-sm text-gray-600">
          <div className="flex flex-wrap gap-4">
            <span>페이지 수: {metadata.pages}</span>
            <span>예상 읽기 시간: {metadata.statistics.estimatedReadTime}분</span>
            <span>총 글자 수: {metadata.statistics.totalLength}</span>
          </div>
        </div>
      )}
      
      {/* 요약 섹션 */}
      {summaryText && (
        <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
          <h3 className="text-xl font-semibold mb-4 text-blue-600 flex items-center">
            <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
            </svg>
            문서 요약
          </h3>
          <p className="text-gray-700 whitespace-pre-wrap leading-relaxed">{summaryText}</p>
        </div>
      )}

      {/* 주요 포인트 섹션 */}
      {keyPoints?.length > 0 && (
        <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
          <h3 className="text-xl font-semibold mb-4 text-blue-600 flex items-center">
            <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"/>
            </svg>
            주요 포인트
          </h3>
          <ul className="list-none space-y-3">
            {keyPoints.map((point, index) => (
              <li key={index} className="flex items-start">
                <span className="flex-shrink-0 w-6 h-6 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mr-3 mt-0.5">
                  {index + 1}
                </span>
                <span className="text-gray-700">{point}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* 문서 구조 섹션 */}
      {structure && (
        <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
          <h3 className="text-xl font-semibold mb-4 text-blue-600 flex items-center">
            <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"/>
            </svg>
            문서 구조
          </h3>
          {structure.introduction && (
            <div className="mb-6">
              <h4 className="font-medium text-lg text-blue-800 mb-2">도입</h4>
              <p className="text-gray-700 bg-blue-50 p-4 rounded-lg">{structure.introduction}</p>
            </div>
          )}
          {structure.mainPoints?.length > 0 && (
            <div className="mb-6">
              <h4 className="font-medium text-lg text-blue-800 mb-2">주요 내용</h4>
              <ul className="space-y-3">
                {structure.mainPoints.map((point, index) => (
                  <li key={index} className="flex items-start bg-gray-50 p-4 rounded-lg">
                    <span className="flex-shrink-0 w-6 h-6 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mr-3 mt-0.5">
                      {index + 1}
                    </span>
                    <span className="text-gray-700">{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
          {structure.conclusion && (
            <div>
              <h4 className="font-medium text-lg text-blue-800 mb-2">결론</h4>
              <p className="text-gray-700 bg-green-50 p-4 rounded-lg">{structure.conclusion}</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PDFAnalysisResult;